import { LocateResponse } from "../models";

export const getHostnameForSpeedtestServerNdt7 = async (): Promise<LocateResponse> => {
    const locateServerUrl = 'https://locate.measurementlab.net/v2/nearest/ndt/ndt7';

    return await getLocateResponse(locateServerUrl);
};

const getLocateResponse = async (request: RequestInfo): Promise<LocateResponse> => {
    const response = await fetch(request);
    if (response.status === 204) {
        throw new Error(`Client has been rate limited.`);
    }
    if (response.status < 200 || response.status > 300) {
        throw new Error(`Call to ${request} failed: ${response.statusText}`);
    }
    return await response.json();
};